<ng-template [ngIf]="headers.length > 0">
  <ng-template [ngIf]="!mobileView">
    <ng-template [ngIf]="directModeEnabled">
      <div class="row" style="margin-bottom: 5px !important;">
        <div class="b-radius relative flex full-width bg-orange padding10 align-centre" style="height: 70px">
          <span class="font25 textBlack">
            <fa-icon [icon]="faTriangleExclamation" style="margin-right: 20px;"></fa-icon>
          </span>
          <div style="display: grid;">
            <span class="font15 textBlack">
              {{app.translations.GBL_lbl_DirectModeEnabled}}
            </span>
            <span class="font15 textBlack">
              {{app.translations.GBL_lbl_DirectModeWarning}}
            </span>
          </div>
          <button class="btn textBlack font15 bg-dark-secondary absolute" (click)="exitDirectMode()"
            style="margin-right: 15px; top: 50%; right: 0px; transform: translateY(-50%)">{{app.translations.GBL_btn_Reload}}</button>
        </div>
      </div>
    </ng-template>
    <div class="row" style="margin-bottom: 10px !important; margin-top: 5px !important;"
      [ngClass]="[settings.darkModeSetting ? 'bg-dark' : 'bg-white', settings.freeColumnResizeSetting ? 'sticky-controlbar' : '']">
      <div class="col-12">
        <div class="padding5 b-radius control-bar"
          [ngClass]="[settings.darkModeSetting ? 'bg-dark-secondary' : 'bg-light-blue', zoomedDetailView ? 'display-none' : '']">
          <div class="col-5 flex unset-p">
            <button class="btn font17" (click)="toggleCompactGrid()" pTooltip="Ctrl-Shft-Z" tooltipPosition="top">
              <fa-icon [icon]="faDownLeftAndUpRightToCenter"
                class="padding3 b-radius textGreen control-bar-btn-icon"></fa-icon>
            </button>
            <div class="relative" (mouseenter)="showAdvancedFiltersButton = true"
              (mouseleave)="showAdvancedFiltersButton = false">
              <button class="btn font17" (click)="toggleFilters()" [disabled]="showAdvancedFilters && showFilters"
                pTooltip="Ctrl-Shft-F" tooltipPosition="top">
                <fa-icon [icon]="faFilter" class="padding3 b-radius textGreen control-bar-btn-icon"></fa-icon>
                <span class="control-bar-btn-text"
                  [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{app.translations.GBL_btn_FilterText}}</span>
              </button>
              <ng-template [ngIf]="showAdvancedFiltersButton">
                <div class="absolute box-shadow b-radius" style="top: 35px; z-index: 1;"
                  [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
                  <button class="btn font17" (click)="openAdvancedFilters()">
                    <fa-icon [icon]="faPlus" class="padding3 b-radius textGreen control-bar-btn-icon"></fa-icon>
                    <span class="control-bar-btn-text" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                      {{app.translations.GBL_btn_AdvancedFiltersText}}
                    </span>
                  </button>
                </div>
              </ng-template>
            </div>
            <button class="btn font17" (click)="openColumnDialog()" [disabled]="directModeEnabled"
              [ngClass]="directModeEnabled ? 'cursorNotAllowed' : 'cursorPointer'" pTooltip="Ctrl-Shft-Q"
              tooltipPosition="top">
              <fa-icon [icon]="faTableColumns" class="padding3 b-radius textGreen control-bar-btn-icon"></fa-icon>
              <ng-template [ngIf]="!mobileView">
                <span class="control-bar-btn-text"
                  [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{app.translations.GBL_btn_ColumnsText}}</span>
              </ng-template>
            </button>
            <button class="btn font17" (click)="exportData()" pTooltip="Ctrl-Shft-E" tooltipPosition="top">
              <fa-icon [icon]="faFileExport" class="padding3 b-radius textGreen control-bar-btn-icon"></fa-icon>
              <span class="control-bar-btn-text"
                [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{app.translations.GBL_btn_Export}}</span>
            </button>
            <span [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
              class="font14 animated fadeIn padding10 justify-centre align-centre b-radius record-count">
              {{rowCountFrom}} - {{rowCountTo}} {{app.translations.GBL_lbl_Of}} {{totalRecords}}
              {{app.translations.GBL_lbl_Rows}}
            </span>
          </div>
          <div class="offset-4 col-3 flex unset-p flex justify-right align-centre page-controls-container">
            <select class="font14 unset-b padding5 b-radius unset-outline cursorPointer"
              [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary textWhite' : 'bg-white textBlack'"
              (change)="changePageSize($event)">
              <option class="textBlack" [selected]="pageSize == 50000">{{app.translations.GBL_lbl_AllPageLength}}
              </option>
              <option class="textBlack" [selected]="pageSize == 10">10</option>
              <option class="textBlack" [selected]="pageSize == 20">20</option>
              <option class="textBlack" [selected]="pageSize == 50">50</option>
              <option class="textBlack" [selected]="pageSize == 100">100</option>
            </select>
            <div class="p-mb-3 flex justify-right align-centre paginator">
              <button (click)="first()" class="btn font17 textGreen" [disabled]="isFirstPage()"
                pTooltip="{{app.translations.GBL_hint_PaginateFirst}}" tooltipPosition="top"
                [ngClass]="{'cursorPointer': !isFirstPage(), 'cursorNotAllowed': isFirstPage()}">
                <fa-icon [icon]="faAnglesLeft"></fa-icon>
              </button>
              <button (click)="prev()" class="btn font17 textGreen"
                [ngClass]="{'cursorPointer': !isFirstPage(), 'cursorNotAllowed': isFirstPage()}"
                pTooltip="{{app.translations.GBL_hint_PaginatePrevious}}" tooltipPosition="top"
                [disabled]="isFirstPage()">
                <fa-icon [icon]="faChevronLeft"></fa-icon>
              </button>
              <span [ngClass]="settings.darkModeSetting ? 'textWhite bg-dark-secondary' : 'textBlack bg-white'"
                class="font15 page-number transition5 b-radius">
                {{currentpage}}
              </span>
              <button (click)="next()" class="btn font17 textGreen"
                [ngClass]="{'cursorPointer': !isLastPage(), 'cursorNotAllowed': isLastPage()}"
                pTooltip="{{app.translations.GBL_hint_PaginateNext}}" tooltipPosition="top" [disabled]="isLastPage()">
                <fa-icon [icon]="faChevronRight"></fa-icon>
              </button>
              <button (click)="last()" class="btn font17 textGreen" [disabled]="isLastPage()"
                pTooltip="{{app.translations.GBL_hint_PaginateLast}}" tooltipPosition="top"
                [ngClass]="{'cursorPointer': !isLastPage(), 'cursorNotAllowed': isLastPage()}">
                <fa-icon [icon]="faAnglesRight"></fa-icon>
              </button>
            </div>
            <button (click)="toggleWidgets()" pTooltip="Widgets" tooltipPosition="top" class="textGreen btn font17">
              <fa-icon [icon]="faGripVertical"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div #tabelDiv class="animated fadeIn grid-data-container sticky-grid flex" (scroll)="onScroll()"
      [ngStyle]="{'width': settings.freeColumnResizeSetting ? 'max-content' : '100%' }"
      [class.disable-selection]="shiftSelect || controlSelect">
      <div class="grid-table" [ngClass]="{'display-none': widgetMax}">
        <p-table #dt [value]="lines" [columns]="headers" [reorderableColumns]="true" (onColReorder)="handleColReorder()"
          [columnResizeMode]="settings.freeColumnResizeSetting ? 'expand' : 'fit'" styleClass="p-datatable-gridlines"
          [resizableColumns]="true" responsiveLayout="scroll" (onColResize)="handleColResize()">
          <ng-template [ngIf]="headers.length > 0">
            <ng-template pTemplate="header" let-columns>
              <!--#region Headers  -->
              <tr (mouseover)="getViewName()" class="sticky-headers" [ngClass]="zoomedDetailView ? 'display-none' : ''">
                <ng-template [ngIf]="hasChildren">
                  <th class="arrow-column unset-p" pResizableColumn
                    style="max-width: 50px !important; width: 50px !important;"
                    [ngClass]="[settings.darkModeSetting ? 'bg-dark-dark' : 'bg-green']">
                    <button type="button" class="btn font14 unset-p" (click)="collapse(undefined)">
                      <fa-icon [icon]="faAngleDoubleUp"
                        [ngClass]="[settings.darkModeSetting ? 'textGreen' : 'textWhite', 'font' + settings.textSizeSetting, 'padding' + settings.globalPadding]"></fa-icon>
                    </button>
                  </th>
                </ng-template>
                <ng-container *ngFor="let header of headers">
                  <ng-container *ngFor="let filter of filters">
                    <ng-template [ngIf]="header.visible && header.caption == filter.caption">
                      <th #tablerow pResizableColumn pReorderableColumn class="fit-content-max-width"
                        [ngStyle]="{'width': header.width }" (dblclick)="sort(undefined)"
                        (contextmenu)="openContextMenu($event, header, undefined)"
                        [ngClass]="['padding' + settings.globalPadding, 'font' + settings.textSizeSetting, settings.darkModeSetting ? 'bg-dark-dark': 'bg-green']">
                        <span class="word-break" (click)="sort(header)" [ngClass]="{'sorted-column': header.sortedBy,
                              'active-filter': filter.isActive && !settings.darkModeSetting,
                              'active-filter-dark': filter.isActive && settings.darkModeSetting,
                              'textGreyb9': filter.isNull,
                              'textWhite': !filter.isNull && !settings.darkModeSetting,
                              'textGreen': !filter.isNull && settings.darkModeSetting,
                              'cursorPointer': header.displayFormat != 'IMAGE',
                              'cursorNotAllowed': header.displayFormat == 'IMAGE'}">
                          <ng-template [ngIf]="sortString && header.sortedBy">
                            <fa-icon [icon]="sortOrder ? faArrowUpLong : faArrowDownLong"
                              [ngClass]="['font' + settings.textSizeSetting, 'padding' + settings.globalPadding]"></fa-icon>
                          </ng-template>
                          {{header.caption}}
                        </span>
                        <ng-template [ngIf]="header.appliedCalculationType && header.appliedCalculationValue != null">
                          <br>
                          <span class="animated fadeIn" [ngClass]="settings.darkModeSetting ? 'textGreen': 'textWhite'">
                            {{header.appliedCalculationType}}: {{header.appliedCalculationValue}}
                          </span>
                        </ng-template>
                      </th>
                    </ng-template>
                  </ng-container>
                </ng-container>
              </tr>
              <ng-template [ngIf]="showFilters">
                <tr class="animated fadeIn" [ngClass]="zoomedDetailView ? 'display-none' : ''">
                  <ng-template [ngIf]="hasChildren">
                    <td class="arrow-column" pResizableColumn
                      style="min-width: 50px !important; max-width: 50px !important; width: 50px !important;"
                      [ngClass]="[settings.darkModeSetting ? 'bg-dark' : 'bg-white']"></td>
                  </ng-template>
                  <ng-container *ngFor="let header of headers">
                    <ng-container *ngFor="let filter of filters">
                      <ng-template [ngIf]="header.visible && header.caption == filter.caption">
                        <ng-template [ngIf]="filter.displayFormat == 'TIME' || filter.displayFormat.includes('DATE')">
                          <td (dblclick)="clearFilter(filter)" class="relative cursorPointer"
                            [ngClass]="['padding' + settings.globalPadding, settings.darkModeSetting ? 'bg-dark' : 'bg-white']"
                            (contextmenu)="nullifyFilter(filter, $event)">
                            <button class="absolute bg-none unset-p unset-b range-filter-btn" tooltipPosition="top"
                              [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack']"
                              (click)="op.toggle($event)" pTooltip="{{getFilterTooltip(filter)}}"
                              [disabled]="!filteredByEditableFilterString && showAdvancedFilters"
                              [tooltipDisabled]="!filter.isActive || filter.isNull" #inputRef>
                              <fa-icon [icon]="faDownLeftAndUpRightToCenter"></fa-icon>
                            </button>
                            <ng-template [ngIf]="filter.isNull">
                              <span class="font14 italic textGreyb9" style="padding-left: 5px;">(null)</span>
                            </ng-template>
                            <p-overlayPanel #op>
                              <ng-template pTemplate="content">
                                <div class="b-radius box-shadow" style="padding: 20px 0px 10px;"
                                  [ngClass]="[settings.darkModeSetting ? 'bg-dark' : 'bg-white']">
                                  <div class="row">
                                    <div class="col-6">
                                      <span class="font12"
                                        [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                                        {{app.translations.GBL_lbl_RangeFrom}}
                                      </span><br>
                                      <ng-template [ngIf]="filter.displayFormat == 'TIME'">
                                        <input class="form-control textBlack font14 input-filter" step=60 type="time"
                                          #txtTo [(ngModel)]="filter.ranges.from" />
                                      </ng-template>
                                      <ng-template [ngIf]="filter.displayFormat != 'TIME'">
                                        <date-picker (dateSelected)="fromDateUpdated($event, filter)"
                                          [filterFromValue]="filter.ranges.userDateFrom"
                                          [settings]="settings"></date-picker>
                                      </ng-template>
                                    </div>
                                    <div class="col-6">
                                      <span class="font12"
                                        [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                                        {{app.translations.GBL_lbl_RangeTo}}
                                      </span><br>
                                      <ng-template [ngIf]="filter.displayFormat == 'TIME'">
                                        <input class="form-control textBlack font14 input-filter" step=60 type="time"
                                          #txtTo [(ngModel)]="filter.ranges.to" />
                                      </ng-template>
                                      <ng-template [ngIf]="filter.displayFormat != 'TIME'">
                                        <date-picker (dateSelected)="toDateUpdated($event, filter)"
                                          [filterToValue]="filter.ranges.userDateTo"
                                          [settings]="settings"></date-picker>
                                      </ng-template>
                                    </div>
                                  </div><br />
                                  <div class="row">
                                    <div class="col-12 flex justify-right">
                                      <button class="btn font17" (click)="createRangeFilter(filter)">
                                        <fa-icon [icon]="faCheck"
                                          class="textGreen padding3 b-radius control-bar-btn-icon"></fa-icon>
                                        <span class="control-bar-btn-text"
                                          [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                                          {{app.translations.GBL_btn_ApplyText}}
                                        </span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </ng-template>
                            </p-overlayPanel>
                          </td>
                        </ng-template>
                        <ng-template [ngIf]="filter.displayFormat == 'CHECK'">
                          <td (dblclick)="clearFilter(filter)"
                            [ngClass]="['padding' + settings.globalPadding, settings.darkModeSetting ? 'bg-dark' : 'bg-white']">
                            <mat-checkbox #chk [disabled]="!filteredByEditableFilterString && showAdvancedFilters"
                              [checked]="preSelectCheckBoxFilter(filter)" [indeterminate]="filter.isNull"
                              (change)="updateValue(chk.value, filter, $event)" #inputRef
                              (contextmenu)="nullifyFilter(filter)">
                            </mat-checkbox>
                          </td>
                        </ng-template>
                        <ng-template [ngIf]="filter.displayFormat == '' || filter.displayFormat == 'string'
                              || filter.displayFormat == 'IMAGE' || header.displayFormat == 'HTML'">
                          <td (dblclick)="clearFilter(filter)" class="relative"
                            [ngClass]="['padding' + settings.globalPadding, settings.darkModeSetting ? 'bg-dark' : 'bg-white']">
                            <ng-template [ngIf]="filterDelaySetting">
                              <input class="form-control b-radius input-filter" type="text" #txtFilter
                                [ngClass]="['font' + settings.textSizeSetting, 'padding' + settings.globalPadding, settings.darkModeSetting ? 'textWhite' : 'textBlack']"
                                placeholder="..." (keyup)="updateValue(txtFilter.value, filter, $event)"
                                [disabled]="header.displayFormat == 'IMAGE' || filter.dataType == 'Byte[]' || (!filteredByEditableFilterString && showAdvancedFilters)"
                                [value]="header.field == filter.field ? filter.value : ''" (click)="focusFilter(filter)"
                                #inputRef (contextmenu)="openContextMenu($event, filter, undefined)" />
                            </ng-template>
                            <ng-template [ngIf]="!filterDelaySetting">
                              <input class="form-control b-radius input-filter" type="text" #txtFilter
                                [ngClass]="['font' + settings.textSizeSetting, 'padding' + settings.globalPadding, settings.darkModeSetting ? 'textWhite' : 'textBlack']"
                                placeholder="..." (keyup)="updateValue(txtFilter.value, filter, $event)"
                                (blur)="buildFilterString()"
                                [disabled]="header.displayFormat == 'IMAGE' || filter.dataType == 'Byte[]' || (!filteredByEditableFilterString && showAdvancedFilters)"
                                [value]="header.field == filter.field ? filter.value : ''" tooltipPosition="top"
                                (click)="focusFilter(filter)" #inputRef
                                pTooltip="{{app.translations.GBL_hint_HitEnterToApply}}"
                                [tooltipDisabled]="settings.filterDelaySetting"
                                (contextmenu)="openContextMenu($event, filter, undefined)" />
                            </ng-template>
                            <ng-template
                              [ngIf]="filter.showHistory && filter.filteredHistory.length > 0 && settings.filterHistorySetting">
                              <div class="box-shadow absolute full-width padding10 text-left b-radius"
                                [ngClass]="settings.darkModeSetting ? 'textWhite bg-dark' : 'textBlack bg-light-blue'">
                                <ng-container *ngFor="let value of filter.filteredHistory">
                                  <div class="full-width cursorPointer historyValueContainer padding5 b-radius"
                                    (click)="updateFilterFromHistory(value, filter)" style="margin-bottom: 5px">
                                    <span class="font13"
                                      [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{value}}</span>
                                  </div>
                                </ng-container>
                              </div>
                            </ng-template>
                          </td>
                        </ng-template>
                      </ng-template>
                    </ng-container>
                  </ng-container>
                </tr>
              </ng-template>
              <ng-template [ngIf]="showAdvancedFilters">
                <tr class="animated fadeIn" [ngClass]="zoomedDetailView ? 'display-none' : ''">
                  <td [attr.colspan]="headers.length+1" class="relative"
                    [ngClass]="['padding' + settings.globalPadding, settings.darkModeSetting ? 'bg-dark' : 'bg-white']">
                    <input #filterInput [value]="editableFilterString"
                      class="form-control input-filter transition4 font13"
                      [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                      style="padding: 5px 5px 5px 105px;"
                      [ngStyle]="{'border-color': editableFilterStringError.length > 0 ? 'var(--red)' : '#ced4da'}" />
                    <ng-template [ngIf]="editableFilterStringError.length > 0">
                      <fa-icon [icon]="faInfoCircle"
                        class="padding3 b-radius textRed absolute font14 cursorPointer advancedFilterErrorIcon"
                        pTooltip="{{editableFilterStringError}}" tooltipPosition="top"></fa-icon>
                    </ng-template>
                    <div class="absolute flex advancedFilterInputButtonContainer">
                      <fa-icon [icon]="faFilter" class="padding3 textGreen font15 cursorPointer"
                        (click)="validateFilterString(filterInput.value)"
                        pTooltip="{{app.translations.GBL_btn_FilterText}}" tooltipPosition="top"></fa-icon>
                      <fa-icon [icon]="faArrowUpRightFromSquare" class="padding3 textGreen font15 cursorPointer"
                        (click)="showAdvancedFiltersDialog()"
                        pTooltip="{{app.translations.GBL_hint_OpenAdvancedFilterDialog}}"
                        tooltipPosition="left"></fa-icon>
                      <fa-icon [icon]="faXmark" class="padding3 textGreen font15 cursorPointer"
                        (click)="closeAdvancedFilters()" pTooltip="{{app.translations.GBL_hint_Close}}"
                        tooltipPosition="top"></fa-icon>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <!--#endregion -->
            </ng-template>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <!--#region Rows -->
            <tr (mouseover)="getViewName()" [ngClass]="zoomedDetailView ? 'display-none' : ''">
              <ng-template [ngIf]="rowData.children.length > 0">
                <td class="transition4 font14 unset-white-space"
                  [ngClass]="['padding' + settings.globalPadding,
                      settings.darkModeSetting ? (rowData.selected ? 'bg-green' : 'bg-dark') : (rowData.selected ? 'bg-mid-blue' : 'bg-white')]">
                  <button type="button" (click)="expand(rowData);"
                    [ngStyle]="{'display': rowData.children.length > 0 ? 'contents' : 'none' }">
                    <fa-icon [icon]="rowData.expanded ? faChevronDown : faChevronRight" class="transition4" [ngClass]="[settings.darkModeSetting ? (rowData.selected ? 'textWhite' : 'textWhite') : (!rowData.selected ? 'textBlack' : 'textWhite'),
                            'font' + settings.textSizeSetting, 'padding' + settings.globalPadding
                          ]"></fa-icon>
                  </button>
                </td>
              </ng-template>
              <ng-container *ngFor="let col of columns">
                <ng-template [ngIf]="col.visible">
                  <td class="cursorPointer transition4" (click)="selectLines(rowData, $event)" [ngClass]="['padding' + settings.globalPadding, compactGrid ? 'compact-grid' : '',
                        settings.darkModeSetting ? (rowData.selected ? 'textWhite bg-green' : 'textWhite bg-dark') :
                        (!rowData.selected ? 'textBlack bg-white' : 'textWhite bg-mid-blue')]"
                    [tooltipDisabled]="!compactGrid || col.displayFormat == 'IMAGE' || col.displayFormat == 'HTML'"
                    pTooltip="{{rowData.list[col.caption]}}" tooltipPosition="top" [autoHide]="false" [showDelay]="500"
                    (contextmenu)="openContextMenu($event, rowData)"
                    (mouseover)="setSelectedLineValueToCopy(rowData.list[col.caption])">
                    <ng-template [ngIf]="col.displayFormat == 'CHECK'">
                      <mat-checkbox [(ngModel)]="rowData.list[col.caption]" [disabled]="true"
                        [indeterminate]="checkIndeterminate(rowData.list[col.caption])">
                      </mat-checkbox>
                    </ng-template>
                    <ng-template [ngIf]="col.displayFormat == 'IMAGE' && rowData.list[col.caption]">
                      <img [src]="app.getFormattedImage(rowData.list[col.caption])" class="padding2 b-radius" width="30"
                        height="30" [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary' : 'bg-white'"
                        (dblclick)="expandImage(rowData.list[col.caption])" />
                    </ng-template>
                    <ng-template [ngIf]="col.displayFormat == 'HTML' && !compactGrid">
                      <div [ngClass]="'font' + settings.textSizeSetting" (click)="$event.stopImmediatePropagation()"
                        [ngStyle]="{'white-space': !compactGrid ? 'normal' : 'nowrap'}"
                        [innerHTML]="rowData.list[col.caption]"></div>
                    </ng-template>
                    <ng-template [ngIf]="col.displayFormat == 'HTML' && compactGrid">
                      <div [ngClass]="'font' + settings.textSizeSetting" (click)="$event.stopImmediatePropagation()"
                        pTooltip="{{getSafeTooltip(rowData.list[col.caption])}}" tooltipPosition="bottom"
                        [escape]="false" [tooltipDisabled]="!compactGrid" [autoHide]="false"
                        [ngStyle]="{'white-space': !compactGrid ? 'normal' : 'nowrap'}"
                        [innerHTML]="rowData.list[col.caption]">
                      </div>
                    </ng-template>
                    <ng-template [ngIf]="col.displayFormat == 'DATE'">
                      <span [ngClass]="'font' + settings.textSizeSetting"
                        [ngStyle]="{'white-space': !compactGrid ? 'normal' : 'nowrap'}">
                        {{rowData.list[col.caption]}}
                      </span>
                    </ng-template>
                    <ng-template [ngIf]="col.displayFormat == 'TIME'">
                      <span [ngClass]="'font' + settings.textSizeSetting"
                        [ngStyle]="{'white-space': !compactGrid ? 'normal' : 'nowrap'}">
                        {{rowData.list[col.caption]}}
                      </span>
                    </ng-template>
                    <ng-template [ngIf]="col.displayFormat == 'DATETIME'">
                      <span [ngClass]="'font' + settings.textSizeSetting"
                        [ngStyle]="{'white-space': !compactGrid ? 'normal' : 'nowrap'}">
                        {{rowData.list[col.caption]}}
                      </span>
                    </ng-template>
                    <ng-template
                      [ngIf]="(col.displayFormat == '' || col.displayFormat == 'string') &&
                          (col.dataType == 'Int32' || col.dataType == 'Int16' || col.dataType == 'Double' || col.dataType == 'Decimal')">
                      <span class="flex" [ngClass]="'font' + settings.textSizeSetting" [ngStyle]="{'white-space': !compactGrid ? 'pre-line' : 'nowrap',
                              'justify-self': settings.textAlignmentSetting ? 'right' : 'center'}">
                        {{ rowData.list[col.caption].trim() }}
                      </span>
                    </ng-template>
                    <ng-template
                      [ngIf]="(col.displayFormat == '' || col.displayFormat == 'string') && col.dataType == 'String'">
                      <span class="flex" [ngClass]="'font' + settings.textSizeSetting" [ngStyle]="{'white-space': !compactGrid ? 'pre-line' : 'nowrap',
                              'justify-self': settings.textAlignmentSetting ? 'left' : 'center',
                              'text-align': settings.textAlignmentSetting ? 'left' : 'center'}">
                        {{ rowData.list[col.caption].trim() }}
                      </span>
                    </ng-template>
                  </td>
                </ng-template>
              </ng-container>
            </tr>
            <ng-template [ngIf]="rowData.expanded && rowData.children.length > 0">
              <tr class="animated fadeIn">
                <td class="unset-p" [attr.colspan]="headers.length+1"
                  [ngClass]="[settings.darkModeSetting ? 'bg-dark' : 'bg-white', zoomedDetailView ? 'unset-b' : '']">
                  <app-detail-grid [settings]="settings" [children]="rowData.children" [rowId]="rowData.rowId"
                    [nodeId]="nodeId" [userId]="userId" [username]="username" [subDetail]="false"
                    (notify)="resetScrollAfterDetailFiltering($event)" [parentGridSelectedLines]="selectedLines"
                    (tableReady)="onDetailGridReady($event)"></app-detail-grid>
                </td>
              </tr>
            </ng-template>
            <!--#endregion -->
          </ng-template>
        </p-table>
        <ng-template [ngIf]="showNoRecordsFoundLabel">
          <span class="font15 padding10 text-centre b-radius inline-block full-width no-records"
            [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary textWhite' : 'bg-light-blue textBlack'">
            {{app.translations.GBL_lbl_NoRecords}}
          </span>
        </ng-template>
      </div>
      <ng-template [ngIf]="widgetVisible">
        <div class="unset-p sticky widget-container"
          [ngStyle]="{'border': widgetMax ? 'unset' : '1px solid var(--blue);' }"
          [ngClass]="{'bg-dark': settings.darkModeSetting, 'bg-white': !settings.darkModeSetting, 'full-width': widgetMax, 'max-widget-container': !widgetMax}">
          <ng-template [ngIf]="!widgetMax">
            <widget [nodeId]="nodeId" [userId]="userId" [settings]="settings" [widgets]="widgets"
              (widgets)="widgetsLoaded($event)"></widget>
          </ng-template>
          <ng-template [ngIf]="widgetMax">
            <widget-expanded [nodeId]="nodeId" [userId]="userId" [settings]="settings"
              [widgets]="widgets"></widget-expanded>
          </ng-template>
        </div>
      </ng-template>
    </div>
  </ng-template>
  <ng-template [ngIf]="mobileView">
    <ng-template [ngIf]="showMobileFilters">
      <div class="relative" style="height: 78svh; overflow-y: scroll;">
        <div class="animated fadeIn full-width mobileSortFilterOverlay"
          [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
          <div class="row">
            <div class="col-6 flex align-centre">
              <span class="font17" style="padding: 5px 0px;"
                [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                {{app.translations.GBL_btn_FilterText}}
              </span>
            </div>
            <div class="col-6 justify-right flex">
              <fa-icon [icon]="faXmark" class=" font16 control-bar-btn-icon"
                [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'" style="padding: 5px 0px;"
                (click)="showMobileFilters = false"></fa-icon>
            </div>
          </div>
          <ng-container *ngFor="let header of headers">
            <ng-container *ngFor="let filter of filters">
              <ng-template [ngIf]="header.visible && header.caption == filter.caption">
                <div class="row" style="margin-bottom: 20px !important;">
                  <div class="col-12">
                    <span [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'" class="font14">
                      {{header.caption}}
                      <fa-icon [icon]="faXmark" class="font16 control-bar-btn-icon mobileClearFilter"
                        [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                        (click)="clearFilter(filter)"></fa-icon>
                    </span><br>
                    <ng-template [ngIf]="filter.displayFormat == 'TIME' || filter.displayFormat.includes('DATE')">
                      <div class="row">
                        <div class="col-6">
                          <span class="font12" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                            {{app.translations.GBL_lbl_RangeFrom}}
                          </span><br>
                          <ng-template [ngIf]="filter.displayFormat == 'TIME'">
                            <input class="form-control textBlack font14 input-filter" step=60 type="time" #txtTo
                              [(ngModel)]="filter.ranges.from" />
                          </ng-template>
                          <ng-template [ngIf]="filter.displayFormat != 'TIME'">
                            <date-picker (dateSelected)="fromDateUpdated($event, filter)"
                              [filterFromValue]="filter.ranges.userDateFrom" [settings]="settings"></date-picker>
                          </ng-template>
                        </div>
                        <div class="col-6">
                          <span class="font12" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                            {{app.translations.GBL_lbl_RangeTo}}
                          </span><br>
                          <ng-template [ngIf]="filter.displayFormat == 'TIME'">
                            <input class="form-control textBlack font14 input-filter" step=60 type="time" #txtTo
                              [(ngModel)]="filter.ranges.to" />
                          </ng-template>
                          <ng-template [ngIf]="filter.displayFormat != 'TIME'">
                            <date-picker (dateSelected)="toDateUpdated($event, filter)"
                              [filterToValue]="filter.ranges.userDateTo" [settings]="settings"></date-picker>
                          </ng-template>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template [ngIf]="header.displayFormat == 'CHECK'">
                      <mat-checkbox #chk [disabled]="!filteredByEditableFilterString && showAdvancedFilters"
                        [checked]="preSelectCheckBoxFilter(filter)" [indeterminate]="filter.isNull"
                        (change)="updateValue(chk.value, filter, $event)">
                      </mat-checkbox>
                    </ng-template>
                    <ng-template [ngIf]="filter.displayFormat == '' || filter.displayFormat == 'string' 
                            || filter.displayFormat == 'IMAGE' || header.displayFormat == 'HTML'">
                      <input class="form-control b-radius input-filter" type="text" #txtFilter
                        [ngClass]="['font' + settings.textSizeSetting, 'padding' + settings.globalPadding, settings.darkModeSetting ? 'textWhite' : 'textBlack']"
                        placeholder="..." (keyup)="updateValue(txtFilter.value, filter, $event)"
                        [disabled]="header.displayFormat == 'IMAGE' || filter.dataType == 'Byte[]' || (!filteredByEditableFilterString && showAdvancedFilters)"
                        [value]="header.field == filter.field ? filter.value : ''" />
                    </ng-template>
                  </div>
                </div>
              </ng-template>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-template>
    <ng-template [ngIf]="showMobileSort">
      <div class="relative" style="height: 78svh; overflow-y: scroll;">
        <div class="animated fadeIn full-width mobileSortFilterOverlay"
          [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
          <div class="row">
            <div class="col-6 flex align-centre">
              <span class="font17" style="padding: 5px 0px;"
                [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                {{app.translations.GBL_hint_ColSortText}}
              </span>
            </div>
            <div class="col-6 justify-right flex">
              <fa-icon [icon]="faXmark" class=" font16 control-bar-btn-icon"
                [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'" style="padding: 5px 0px;"
                (click)="showMobileSort = false"></fa-icon>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <label [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'" class="font14">
                <input type="radio" name="sortOrder" [(ngModel)]="sortOrder" [value]="true">
                {{app.translations.GBL_lbl_Ascending}}
              </label><br>
              <label [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'" class="font14">
                <input type="radio" name="sortOrder" [(ngModel)]="sortOrder" [value]="false">
                {{app.translations.GBL_lbl_Descending}}
              </label>
            </div>
          </div>
          <ng-container *ngFor="let header of headers">
            <ng-template [ngIf]="header.visible">
              <div class="row">
                <div class="col-12">
                  <mat-checkbox [checked]="header.sortedBy" (change)="updateSortByColumnMobile(header)"
                    [disabled]="header.displayFormat == 'IMAGE' || header.displayFormat == 'ICON'">
                    <span [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                      {{header.caption}}
                    </span>
                  </mat-checkbox>
                </div>
              </div>
              <br><br>
            </ng-template>
          </ng-container>
        </div>
      </div>
    </ng-template>
    <ng-template [ngIf]="lines.length > 0 && !showMobileSort && !showMobileFilters">
      <ng-template [ngIf]="!showMobileDetailView">
        <div class="relative" style="height: 78svh; overflow-y: scroll;">
          <ng-template [ngIf]="directModeEnabled">
            <div class="row" style="margin-bottom: 5px !important;">
              <div class="b-radius relative inline-grid full-width bg-orange padding10 align-centre"
                style="height: auto;">
                <span class="font25 textBlack">
                  <fa-icon [icon]="faTriangleExclamation" style="margin-right: 20px;"></fa-icon>
                </span>
                <div style="display: grid;">
                  <span class="font15 textBlack">
                    Direct mode enabled.
                  </span>
                  <span class="font15 textBlack">
                    Filters and sort orders applied are temporary and will be removed on reload.
                  </span>
                </div>
                <button class="btn textBlack font15 bg-dark-secondary full-width"
                  (click)="exitDirectMode()">Reload</button>
              </div>
            </div>
          </ng-template>
          <ng-container *ngFor="let line of lines">
            <div
              [ngStyle]="{'height': line.expanded ? 'auto' : mobileTileSize === 'Small' ? '60px' : mobileTileSize === 'Medium' ? '110px' : 'auto'}"
              class="b-radius relative animated fadeIn transition4 font13 tile-container"
              [attr.id]="'tile-' + line.rowId" [ngClass]="[settings.darkModeSetting && line ? (line.selected ? 'textWhite bg-green' : 'textWhite bg-dark-secondary') : 
                            (!line.selected ? 'textBlack bg-light-blue' : 'textWhite bg-green')]">
              <div class="row" (click)="selectLines(line, $event)">
                <ng-container *ngFor="let header of headers">
                  <ng-container *ngFor="let item of line.list | keyvalue">
                    <ng-template [ngIf]="item && header.visible && item.key.toString() == header.caption">
                      <div class="col-12" style="margin: 5px 0px;" (touchstart)="startLongPress(item)"
                        (touchend)="cancelLongPress()" (touchcancel)="cancelLongPress()" [ngStyle]="{'overflow': !line.expanded ? 'hidden' : 'unset',
                            'text-overflow': !line.expanded ? 'ellipsis' : 'unset',
                            'white-space': !line.expanded ? 'nowrap' : 'unset'}">
                        <span class="bold" [ngClass]="[settings.darkModeSetting && line ? (line.selected ? 'textBlack' : 'textGreen') : 
                            (!line.selected ? 'textGreen' : 'textBlack')]">{{ item.key }}</span><br>
                        <ng-template [ngIf]="header.displayFormat == 'CHECK'">
                          <mat-checkbox [(ngModel)]="item.value" [disabled]="true"
                            [indeterminate]="checkIndeterminate(item.value)">
                          </mat-checkbox>
                        </ng-template>
                        <ng-template
                          [ngIf]="header.displayFormat == '' || header.displayFormat == 'DATE' || 
                              header.displayFormat == 'DATETIME' || header.displayFormat == 'TIME' || header.displayFormat == 'string'">
                          <span>
                            <ng-template [ngIf]="item.value.length > 0">{{ item.value }}</ng-template>
                            <ng-template [ngIf]="item.value.length == 0">-</ng-template>
                          </span>
                        </ng-template>
                        <ng-template [ngIf]="header.displayFormat == 'IMAGE' && item.value">
                          <img [src]="app.getFormattedImage(item.value.toString())" class="padding2 b-radius" width="30" height="30"
                            [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary' : 'bg-white'"
                            (dblclick)="expandImage(item.value)">
                        </ng-template>
                        <ng-template [ngIf]="header.displayFormat == 'HTML'">
                          <div class="poppins" [innerHTML]="item.value"></div>
                        </ng-template>
                      </div>
                    </ng-template>
                  </ng-container>
                </ng-container>
              </div>
              <fa-icon *ngIf="line.children && line.children.length > 0" [icon]="faNetworkWired" class="transition4 absolute font13 padding10"
                (click)="openMobileDetailView(line)" style="top: 0px; right: 25px;"
                [ngClass]="[settings.darkModeSetting && line ? (line.selected ? 'textWhite' : 'textWhite') : (!line.selected ? 'textBlack' : 'textWhite')]"></fa-icon>
              <fa-icon [icon]="faChevronDown" class="transition4 absolute font13 padding10"
                (click)="line.expanded = !line.expanded;" style="top: 0px; right: 0px;"
                [ngClass]="[settings.darkModeSetting && line ? (line.selected ? 'textWhite' : 'textWhite') : (!line.selected ? 'textBlack' : 'textWhite')]"></fa-icon>
            </div>
          </ng-container>
        </div>
      </ng-template>
    </ng-template>
    <ng-template [ngIf]="lines.length == 0 && !showMobileSort && !showMobileFilters">
      <span class="font15 padding10 text-centre b-radius inline-block full-width no-records"
        [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary textWhite' : 'bg-light-blue textBlack'">
        {{app.translations.GBL_lbl_NoRecords}}
      </span>
    </ng-template>
    <ng-template [ngIf]="showMobileDetailView">
      <app-detail-grid [settings]="settings" [children]="mobileDetailViewLine.children"
        [rowId]="mobileDetailViewLine.rowId" [nodeId]="nodeId" [userId]="userId" [username]="username"
        [subDetail]="false" (notify)="resetScrollAfterDetailFiltering($event)" [parentGridSelectedLines]="selectedLines"
        (tableReady)="onDetailGridReady($event)" [mobileView]="mobileView"
        (message)="closeDetailView()" [mainGridName]="mainGridName"></app-detail-grid>
    </ng-template>
    <div *ngIf="!showMobileDetailView" class="row full-width sticky"
      style="bottom: 0px; height: 14svh; border-top: 1px solid;"
      [ngStyle]="{'border-color': settings.darkModeSetting ? 'white' : 'var(--green)'}"
      [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
      <ng-template [ngIf]="showMobileFilters">
        <div class="row sticky mobileSortFilterOverlayFooter"
          [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
          <button class="btn font16" (click)="buildFilterString()">
            <fa-icon [icon]="faCheck" class="textGreen control-bar-btn-icon"></fa-icon>
            <span class="font17 control-bar-btn-text" style="padding: 0px 5px;"
              [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{app.translations.GBL_btn_ApplyText}}</span>
          </button>
        </div>
      </ng-template>
      <ng-template [ngIf]="showMobileSort">
        <div class="row sticky mobileSortFilterOverlayFooter"
          [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
          <button class="btn font16" (click)="sortFromMobile()">
            <fa-icon [icon]="faCheck" class="textGreen control-bar-btn-icon"></fa-icon>
            <span class="font17 control-bar-btn-text" style="padding: 0px 5px;"
              [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{app.translations.GBL_btn_ApplyText}}</span>
          </button>
        </div>
      </ng-template>
      <div class="padding5 control-bar">
        <ng-template [ngIf]="!showMobileSort && !showMobileFilters">
          <div class="col-12 flex unset-p">
            <span [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
              class="font14 animated fadeIn padding10 justify-centre align-centre b-radius record-count">
              {{rowCountFrom}} - {{rowCountTo}} {{app.translations.GBL_lbl_Of}} {{totalRecords}}
              {{app.translations.GBL_lbl_Rows}}
            </span>
            <select class="font14 unset-b padding5 b-radius unset-outline cursorPointer"
              [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary textWhite' : 'bg-white textBlack'"
              (change)="changePageSize($event)">
              <option class="textBlack">10</option>
              <option class="textBlack" selected>20</option>
              <option class="textBlack">50</option>
              <option class="textBlack">100</option>
            </select>
            <div class="p-mb-3 flex justify-right align-centre paginator">
              <button (click)="first()" class="btn font17 textGreen" [disabled]="isFirstPage()"
                pTooltip="{{app.translations.GBL_hint_PaginateFirst}}" tooltipPosition="top"
                [ngClass]="{'cursorPointer': !isFirstPage(), 'cursorNotAllowed': isFirstPage()}">
                <fa-icon [icon]="faAnglesLeft"></fa-icon>
              </button>
              <button (click)="prev()" class="btn font17 textGreen"
                [ngClass]="{'cursorPointer': !isFirstPage(), 'cursorNotAllowed': isFirstPage()}"
                pTooltip="{{app.translations.GBL_hint_PaginatePrevious}}" tooltipPosition="top"
                [disabled]="isFirstPage()">
                <fa-icon [icon]="faChevronLeft"></fa-icon>
              </button>
              <span [ngClass]="settings.darkModeSetting ? 'textWhite bg-dark-secondary' : 'textBlack bg-white'"
                class="font15 page-number transition5 b-radius">
                {{currentpage}}
              </span>
              <button (click)="next()" class="btn font17 textGreen"
                [ngClass]="{'cursorPointer': !isLastPage(), 'cursorNotAllowed': isLastPage()}"
                pTooltip="{{app.translations.GBL_hint_PaginateNext}}" tooltipPosition="top" [disabled]="isLastPage()">
                <fa-icon [icon]="faChevronRight"></fa-icon>
              </button>
              <button (click)="last()" class="btn font17 textGreen" [disabled]="isLastPage()"
                pTooltip="{{app.translations.GBL_hint_PaginateLast}}" tooltipPosition="top"
                [ngClass]="{'cursorPointer': !isLastPage(), 'cursorNotAllowed': isLastPage()}">
                <fa-icon [icon]="faAnglesRight"></fa-icon>
              </button>
            </div>
          </div>
        </ng-template>
        <div class="col-12 flex unset-p" style="justify-content: space-evenly;">
          <button class="btn relative" (click)="showMobileSort = !showMobileSort; showMobileFilters = false;"
            style="padding: 10px 8px !important;">
            <fa-icon [icon]="faArrowUpWideShort"
              class="font17 padding3 b-radius textGreen control-bar-btn-icon"></fa-icon>
            <ng-template [ngIf]="sortString && sortString.length > 0">
              <fa-icon [icon]="faCircle" class="absolute font7 mobileActiveSortFilterIndicator" style="top: 4px;"
                [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"></fa-icon>
            </ng-template>
            <span class="absolute font12 mobileActiveSortFilterIndicator"
              style="bottom: 0px; transform: translateX(-50%); left: 50%;"
              [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">Sort</span>
          </button>
          <button class="btn relative" (click)="showMobileFilters = !showMobileFilters; showMobileSort = false;"
            style="padding: 10px 8px !important;">
            <fa-icon [icon]="faFilter" class="font17 padding3 b-radius textGreen control-bar-btn-icon"></fa-icon>
            <ng-template [ngIf]="activeFilterCount > 0">
              <span class="absolute font10 mobileActiveSortFilterIndicator" style="top: 0;"
                [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{activeFilterCount}}</span>
            </ng-template>
            <span class="absolute font12 mobileActiveSortFilterIndicator"
              style="bottom: 0px; transform: translateX(-50%); left: 50%;"
              [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">Filter</span>
          </button>
          <button class="btn relative" (click)="toggleMobileTileSize()"
            style="padding: 10px 8px !important; background-color: unset !important;">
            <fa-icon
              [icon]="mobileTileSize == 'Small' ? faTableCells : mobileTileSize == 'Medium' ? faBorderAll : faSquare"
              class="font17 padding3 b-radius textGreen control-bar-btn-icon"></fa-icon>
            <span class="absolute font12" style="bottom: 0px; transform: translateX(-50%); left: 50%;"
              [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{mobileTileSize}}</span>
          </button>
          <button class="btn relative" (click)="openColumnDialog()" style="padding: 10px 8px !important;">
            <fa-icon [icon]="faTableColumns" class="font17 padding3 b-radius textGreen control-bar-btn-icon"></fa-icon>
            <span class="absolute font12 mobileActiveSortFilterIndicator"
              style="bottom: 0px; transform: translateX(-50%); left: 50%;"
              [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">Columns</span>
          </button>
          <button class="btn relative" (click)="exportData()" style="padding: 10px 8px !important;">
            <fa-icon [icon]="faFileExport" class="font17 padding3 b-radius textGreen control-bar-btn-icon"></fa-icon>
            <span class="absolute font12 mobileActiveSortFilterIndicator"
              style="bottom: 0px; transform: translateX(-50%); left: 50%;"
              [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">Export</span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>
<div #contextMenu *ngIf="contextMenuVisible" class="fixed padding5 b-radius context-menu box-shadow"
  [ngClass]="settings.darkModeSetting ? 'textWhite bg-dark' : 'textBlack bg-light-blue'" [ngStyle]="mobileView ? { top: contextMenuTop + '%',  left: contextMenuLeft + '%',  transform: 'translate(-50%, -50%)' } :
   { top: contextMenuTop + 'px', left: contextMenuLeft + 'px' }" (click)="contextMenuVisible = false">
  <ng-template [ngIf]="contextMenuType == 'filter'">
    <div style="border-bottom: 1px solid;"
      [ngClass]="settings.darkModeSetting ? 'context-menu-item-dark-border' : 'context-menu-item-light-border'">
      <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
        (click)="copyValue(contextMenuObject)">
        <fa-icon [icon]="faCopy" class="textGreen font13 context-menu-item-icon"></fa-icon>
        <span class="font15">{{app.translations.GBL_hint_Copy}}</span>
      </div>
      <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
        (click)="pasteValueIntoFilter(contextMenuObject)">
        <fa-icon [icon]="faPaste" class="textGreen font13 context-menu-item-icon"></fa-icon>
        <span class="font15">{{app.translations.GBL_lbl_Paste}}</span>
      </div>
    </div>
    <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
      (click)="clearFilter(contextMenuObject)">
      <fa-icon [icon]="faEraser" class="textGreen font13 context-menu-item-icon"></fa-icon>
      <span class="font15">{{app.translations.GBL_btn_Clear}}</span>
    </div>
    <div class="full-width cursorPointer flex context-menu-item b-radius padding5" (click)="toggleFilters()">
      <fa-icon [icon]="faEraser" class="textGreen font13 context-menu-item-icon"></fa-icon>
      <span class="font15">{{app.translations.GBL_lbl_ClearAll}}</span>
    </div>
    <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
      (click)="nullifyFilter(contextMenuObject)">
      <fa-icon [icon]="faCircleDot" class="textGreen font13 context-menu-item-icon"></fa-icon>
      <span class="font15">{{app.translations.GBL_lbl_Nullify}}</span>
    </div>
  </ng-template>
  <ng-template [ngIf]="contextMenuType == 'header'">
    <div style="border-bottom: 1px solid;"
      [ngClass]="settings.darkModeSetting ? 'context-menu-item-dark-border' : 'context-menu-item-light-border'">
      <div class="full-width cursorPointer flex context-menu-item b-radius padding5" (click)="sort(contextMenuObject)">
        <fa-icon [icon]="faUpDown" class="textGreen font13 context-menu-item-icon"></fa-icon>
        <span class="font15">{{app.translations.GBL_hint_ColSortText}}</span>
      </div>
      <div class="full-width cursorPointer flex context-menu-item b-radius padding5" (click)="sort(undefined)">
        <fa-icon [icon]="faRemove" class="textGreen font13 context-menu-item-icon"></fa-icon>
        <span class="font15">{{app.translations.GBL_lbl_RemoveSort}}</span>
      </div>
    </div>
    <div style="border-bottom: 1px solid;"
      [ngClass]="settings.darkModeSetting ? 'context-menu-item-dark-border' : 'context-menu-item-light-border'">
      <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
        (click)="getHeaderCalculation(contextMenuObject, 'SUM')">
        <fa-icon [icon]="faPlus" class="textGreen font13 context-menu-item-icon"></fa-icon>
        <span class="font15">{{app.translations.GBL_lbl_Sum}}</span>
      </div>
      <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
        (click)="getHeaderCalculation(contextMenuObject, 'AVG')">
        <fa-icon [icon]="faChartSimple" class="textGreen font13 context-menu-item-icon"></fa-icon>
        <span class="font15">{{app.translations.GBL_lbl_Avg}}</span>
      </div>
      <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
        (click)="getHeaderCalculation(contextMenuObject, 'MIN')">
        <fa-icon [icon]="faCaretDown" class="textGreen font13 context-menu-item-icon"></fa-icon>
        <span class="font15">{{app.translations.GBL_lbl_Min}}</span>
      </div>
      <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
        (click)="getHeaderCalculation(contextMenuObject, 'MAX')">
        <fa-icon [icon]="faCaretUp" class="textGreen font13 context-menu-item-icon"></fa-icon>
        <span class="font15">{{app.translations.GBL_lbl_Max}}</span>
      </div>
      <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
        (click)="removeHeaderCalculation(contextMenuObject)">
        <fa-icon [icon]="faRemove" class="textGreen font13 context-menu-item-icon"></fa-icon>
        <span class="font15">{{app.translations.GBL_lbl_RemoveCalculation}}</span>
      </div>
    </div>
    <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
      (click)="hideColumn(contextMenuObject)">
      <fa-icon [icon]="faEyeSlash" class="textGreen font13 context-menu-item-icon"></fa-icon>
      <span class="font15">{{app.translations.GBL_lbl_HideColumn}}</span>
    </div>
  </ng-template>
  <ng-template [ngIf]="contextMenuType == 'line'">
    <div style="border-bottom: 1px solid;"
      [ngClass]="settings.darkModeSetting ? 'context-menu-item-dark-border' : 'context-menu-item-light-border'">
      <ng-template [ngIf]="!mobileView">
        <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
          (click)="expand(contextMenuObject)">
          <fa-icon [icon]="faAngleDown" class="textGreen font13 context-menu-item-icon"></fa-icon>
          <span class="font15">{{app.translations.GBL_lbl_ExpandLine}}</span>
        </div>
        <div class="full-width cursorPointer flex context-menu-item b-radius padding5"
          (click)="collapse(contextMenuObject)">
          <fa-icon [icon]="faAngleUp" class="textGreen font13 context-menu-item-icon"></fa-icon>
          <span class="font15">{{app.translations.GBL_lbl_CollapseLine}}</span>
        </div>
      </ng-template>
      <div class="full-width cursorPointer flex context-menu-item b-radius padding5" (click)="expand(undefined)">
        <fa-icon [icon]="faAngleDoubleDown" class="textGreen font13 context-menu-item-icon"></fa-icon>
        <span class="font15">{{app.translations.GBL_lbl_ExpandAll}}</span>
      </div>
      <div class="full-width cursorPointer flex context-menu-item b-radius padding5" (click)="collapse(undefined)">
        <fa-icon [icon]="faAngleDoubleUp" class="textGreen font13 context-menu-item-icon"></fa-icon>
        <span class="font15">{{app.translations.GBL_lbl_CollapseAll}}</span>
      </div>
    </div>
    <div class="full-width cursorPointer flex context-menu-item b-radius padding5" (click)="selectAll()">
      <fa-icon [icon]="faSquareCheck" class="textGreen font13 context-menu-item-icon"></fa-icon>
      <span class="font15">{{app.translations.GBL_lbl_SelectAll}}</span>
    </div>
    <div class="full-width cursorPointer flex context-menu-item b-radius padding5" (click)="deselectAll()">
      <fa-icon [icon]="faSquareXmark" class="textGreen font13 context-menu-item-icon"></fa-icon>
      <span class="font15">{{app.translations.GBL_lbl_DeselectAll}}</span>
    </div>
  </ng-template>
</div>